<template>
  <div>
    <div class="editor-wrap" v-if="!editing">
      <span class="value">{{ currentIntegral }}</span>
      <div class="mwow-button-filled mini edit-btn" @click="toggleEditing">
        <i class="iconfont icon-a-bianjixiugai"></i>
      </div>
    </div>
    <div class="editor-wrap" v-else>
      <el-input class="input" v-model.number="currentIntegral" type="number">
        <div slot="suffix">
          <el-button
            class="mwow-button-filled mini save-btn"
            @click="saveEditing"
          >
            <i class="iconfont icon-baocun"></i>
          </el-button>
        </div>
      </el-input>
    </div>
  </div>
</template>
<script>
import { saveTaskIntegralApi } from "@/api/integral";

export default {
  // @Prop() taskKey!: string;
  // @Prop() ori!: number;
  props: ["taskKey", "ori"],
  data() {
    return {
      currentIntegral: 0,
      editing: false,
    };
  },
  // @Watch("ori", { immediate: false, deep: false })
  // originChange(n: any, o: any) {
  //   this.currentIntegral = n || 0;
  // }
  watch: {
    ori: {
      handler(n, o) {
        this.currentIntegral = n || 0;
      },
      immediate: false,
      deep: false,
    },
  },
  created() {
    this.currentIntegral = this.ori || 0;
  },
  methods: {
    toggleEditing() {
      this.editing = !this.editing;
    },
    saveEditing() {
      if (!this.taskKey) {
        return false;
      }
      if (this.currentIntegral > 2147483647) {
        this.$message({
          type: "error",
          message: "数值过大",
        });
        return false;
      }
      if (
        typeof this.currentIntegral !== "number" ||
        this.currentIntegral < 0
      ) {
        this.$message({
          type: "error",
          message: "请填写正整数",
        });
        return false;
      }
      saveTaskIntegralApi({
        task_key: this.taskKey,
        integral: this.currentIntegral,
      })
        .then(() => {
          this.toggleEditing();
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        })
        .catch(() => {
          this.toggleEditing();
          this.currentIntegral = this.ori || 0;
        });
    },
    originChange(n, o) {
      this.currentIntegral = n || 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.editor-wrap {
  display: flex;
  .edit-btn {
    display: none !important;
    border: 0 !important;
    background: none !important;
  }
  &:hover {
    .edit-btn {
      display: block !important;
      line-height: 30px !important;
    }
  }
  .save-btn {
    border: 0 !important;
    background: none !important;
    line-height: 30px !important;
  }
  .value {
    line-height: 30px;
  }
  .input {
  }
}
</style>
